import React, { Component } from 'react';
//import { Container, Row, Col, Spinner } from 'react-bootstrap';
//import ApiService from '../../service/ApiService';
//import { convertToInternationalCurrencySystem } from '../../service/Util';
import { Link } from 'react-router-dom';
import { getPrePostCommData } from '../../service/PrePostService';

class PrePostCommodityPrice extends Component {
    constructor(props) {
        super(props);
        this.state = {
            symbolName: this.props.symbolName,
            ticker: this.props.ticker,
            bgc: this.props.bgc,
            interval: '1min',
            show: false,
        };
    }

    componentDidMount() {
        console.log('PrePostCommodityPrice', this.state.ticker);
        this.getData();
        this.interval = setInterval(() => { this.getData() }, 1000 * 10 * 0.5); //5 mins
    }

    componentWillUnmount() {
        clearInterval(this.interval);
    }

    getData() {
        let result = getPrePostCommData(this.state.ticker);
        if (result !== undefined) {
            this.setState({
                price: result.price,
                change: result.change,
                changesPercentage: result.changesPercentage,
                volume: result.volume,
                show: true
            });
        } else {
            this.setState({
                price: 0,
                change: 0,
                changesPercentage: 0,
                volume: 0,
                show: false
            });
        }
    }

    render() {
        return (
            <>
                <div style={{backgroundColor: this.state.bgc}}>
                    <Link style={{ fontSize: "12px", fontWeight: 'bold', color: parseFloat(this.state.change) >= 0 ? 'green' : 'red' }} to={'/futures/chart/' + this.state.ticker}>{this.state.symbolName}</Link>
                </div>
                {this.state.show ? (
                    <div style={{ fontSize: '10px', fontWeight: 'bold', backgroundColor: this.state.bgc, color: parseFloat(this.state.change) >= 0 ? 'green' : 'red' }}>
                        {parseFloat(this.state.price).toFixed(2)}&nbsp;&nbsp;&nbsp;
                        {parseFloat(this.state.change).toFixed(2)}&nbsp;
                        ({parseFloat(this.state.changesPercentage).toFixed(2)}%)
                    </div>
                ) : (
                    <div style={{backgroundColor: this.state.bgc}}>
                        <i className={'fa fa-spinner fa-pulse'} ></i>
                    </div>
                )}
            </>
        );

    }
}

export default PrePostCommodityPrice;
